import React, { useState } from "react";
import { Toast } from "../../../components/Toast/Toast";
import { useUserInfo } from "../../../context/user";
import axios from "axios";
import YoureAllSet from "./YoureAllSet";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppServices } from "../../../hook/services";
import env from "../../../config/env";

const ConfigureYourAIDetail = ({ setBusinessType, business_name, HandleEveryStep }) => {
  const BASE_URL = `${env.API_URL}/v1`;
  const [
    userInfo, // user, Update, clear
    ,
    ,
    setUserActiveLocation,
    userActiveLocation,
    saveActiveLocation, // ⬅️ we’ll reuse the existing helper
  ] = useUserInfo();
  const [fields, setFields] = useState({
    who: "",
    about: "",
    achieve: "",
  });
  const [errors, setErrors] = useState({
    who: false,
    about: false,
    achieve: false,
  });

  const [toastVisible, setToastVisible] = useState(false);
  const [toastType, setToastType] = useState("error");
  const [toastMessage, setToastMessage] = useState("");
  const [showAllSet, setShow] = useState(false);
  const [toastSubMessage, setToastSubMessage] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // spinner during POST
  const Service = useAppServices();

  const location = useLocation();
  const { accountDataLocation } = location.state || {};

  console.log("Account ID from navigation:", accountDataLocation);

  const showToast = (type, message) => {
    setToastType(type);
    setToastMessage(message);
    setToastVisible(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {
      who: !fields.who.trim(),
      about: !fields.about.trim(),
      achieve: !fields.achieve.trim(),
    };
    setErrors(newErrors);
    const hasError = Object.values(newErrors).some(Boolean);

    if (hasError) {
      showToast("error", "Incomplete fields");
    } else {
      const payload = {
        profileId: accountDataLocation
          ? accountDataLocation
          : userActiveLocation.id,
        username: userActiveLocation.business_name || userActiveLocation?.first_name,
        agency_id: userActiveLocation.agency_id,
        email: userInfo?.email,
        form: [
          { label: "Who are you?", value: fields.who },
          {
            label: "Please tell us what you are all about",
            value: fields.about,
          },
          {
            label: "What can we help you achieve with AI?",
            value: fields.achieve,
          },
        ],
      };

      try {
        setLoading(true);
        setShow(true);
        const onboardingRes = await axios.post(
          `${BASE_URL}/users/onboarding`,
          payload
        );
        const { response } = await Service.accounts.update({
          payload: {
            onboarding: {
              ...userActiveLocation.onboarding,
              form: [
                { label: "Who are you?", value: fields.who },
                {
                  label: "Please tell us what you are all about",
                  value: fields.about,
                },
                {
                  label: "What can we help you achieve with AI?",
                  value: fields.achieve,
                },
              ],
              email: userInfo.email,
              verified: userInfo?.verified ?? true,
            },
            _id: accountDataLocation
              ? accountDataLocation
              : userActiveLocation.id,
          },
          toaster: true,
        });

        if (response?.success) {
          HandleEveryStep(5);
          await saveActiveLocation(response.data)
          setUserActiveLocation(response.data);
          setToastMessage(null);
          setLoading(false);
        }
      } catch (error) {
        if (
          error.response?.data?.error?.error ===
          "Bad request, no abstract generated"
        ) {
          setToastType("error");
          setToastMessage(
            "We need a bit more information to personalise Your AI"
          );
          setToastSubMessage(
            ""
          );
          setToastVisible(true);
        } else {
          console.error("Submission failed:", error);
          showToast("error", "Submission failed. Please try again.");
        }
        setLoading(false);
      }
    }
  };

  if (showAllSet) {
    return (
      <YoureAllSet
        success={loading}
        onComplete={async () => {
          if (!toastMessage && !loading) {
            // Check if payment is required before navigating
            if (userActiveLocation?.type === "premium" && !userActiveLocation?.subscription_id) {
              try {
                const resp = await Service.saas.fetchPlanById({ plan: userActiveLocation.plan_id });
                if (!resp.response?.data?.is_free_saas) {
                  navigate("/auth/add-payment");
                  return;
                }
              } catch (e) {
                console.error("Error checking plan:", e);
              }
            }
            navigate("/app/chat")
          } else if (toastMessage || loading) {
            // If there's an error or still loading, reset to show the form again
            setShow(false)
            if (loading) {
              setToastType("error");
              setToastMessage("Request Timeout!");
              setToastSubMessage("Unexpected error occurred");
              setToastVisible(true);
              setLoading(false)
            }
          }
        }}
      />
    );
  }

  return (
    <div className="container-main !w-[669px] bg-white mt-44">
      <div className="container bg-white">
        <div className="text-center">
          <h1 className="text-[30px] font-medium">Configure Your AI</h1>
          <p
            className={`mt-4 ${toastMessage ? "text-[#C00F0C]" : "text-black"}`}
          >
            {toastMessage && toastMessage + " " + toastSubMessage}
          </p>
          <p className="mt-4">This is how we train Your AI</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="space-y-7 text-start w-[669px] mx-auto mt-5">
            <div>
              <label
                className={`!font-medium ${errors.who ? "text-red-500" : ""}`}
              >
                Who are you?
              </label>
              <textarea
                name="who"
                value={fields.who}
                onChange={handleChange}
                className={`mt-[18px] w-full py-3 px-4 border-2 !border-[#D9D9D9] rounded-md resize-none focus:outline-none focus:ring-0 focus:ring-black ${errors.who ? "!border-red-500 !border-2 focus:ring-0" : ""
                  }`}
                placeholder="Tell us what makes you or your business tick, sparkle—or occasionally grumble. What’s your superpower?"
                style={{ minHeight: "72px", maxHeight: "120px" }}
              />
            </div>

            <div>
              <label
                className={`!font-medium ${errors.about ? "text-red-500" : ""}`}
              >
                Please tell us what you are all about
              </label>
              <textarea
                name="about"
                value={fields.about}
                onChange={handleChange}
                className={`mt-[18px] w-full py-3 px-4 border-2 !border-[#D9D9D9] rounded-md resize-none overflow-y-auto focus:outline-none focus:ring-0 focus:ring-black ${errors.about ? "!border-red-500 !border-2 focus:ring-0" : ""
                  }`}
                placeholder="Help the AI get to know you! What’s your mission, what problems do you solve, and what gets you excited (besides Fridays)? No elevator pitch needed—just be you."
                style={{
                  minHeight: "72px",
                  maxHeight: "120px",
                  height: "120px",
                }}
              />
            </div>

            <div>
              <label
                className={`!font-medium ${errors.achieve ? "text-red-500" : ""
                  }`}
              >
                What can we help you achieve with AI?
              </label>
              <textarea
                name="achieve"
                value={fields.achieve}
                onChange={handleChange}
                className={`mt-[18px] w-full py-3 px-4 border-2 !border-[#D9D9D9] rounded-md resize-none focus:outline-none focus:ring-0 focus:ring-black ${errors.achieve ? "!border-red-500 !border-2 focus:ring-0" : ""
                  }`}
                placeholder="What does success look like for you? Whether it’s saving time, scaling up, or solving a specific challenge, tell us your goals so we can tailor AI to help."
                style={{ minHeight: "72px", maxHeight: "120px" }}
              />
            </div>
          </div>

          <button
            type="submit"
            className="mt-8 w-full bg-black text-white py-3 border-2 !border-[#D9D9D9] rounded-md "
          >
            Let’s go!
          </button>
          {Object.values(errors).some(Boolean) && (
            <div className="text-red-500 text-center mt-4 text-sm font-medium">
              ⚠️️ Please compete all fields to proceed
            </div>
          )}
        </form>
      </div>
      <span
        onClick={() => setBusinessType(null)}
        className="text-[#757575] text-[12px] mt-4 text-start flex float-start cursor-pointer"
      >
        ← Go back
      </span>

      <Toast
        type={toastType}
        message={toastMessage}
        visible={toastVisible}
        subMessage={toastSubMessage}
        onClose={() => setToastVisible(false)}
      />
    </div>
  );
};

export default ConfigureYourAIDetail;
